import { render, staticRenderFns } from "./IndividualAccount.vue?vue&type=template&id=24acf0ec&"
import script from "./IndividualAccount.vue?vue&type=script&lang=js&"
export * from "./IndividualAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports